<template>
  <b-modal
    id="usage-limit-dialog"
    body-class="body-wrapper text-center"
    hide-header
    hide-footer
    centered
  >
    <div>
      <img :src="require(`@/assets/images/alert-report-danger.png`)" width="160px" />
    </div>
    <div class="content-wrapper">
      <div class="fs-5 fw-bold">
        {{ $t('routeOptimization.quota.limitReachedTitle') }}
      </div>
      <div class="text-secondary">
        {{ $t('routeOptimization.quota.limitReachedDesc') }}
      </div>
      <div class="usage-limit-wrapper">
        <div class="d-flex justify-content-between">
          <div>{{ $t('routeOptimization.quota.quotaTitle') }}</div>
          <div class="text-secondary">
            {{ $t('routeOptimization.quota.remaining') }}
            <span class="text-danger">{{ routeOptimizationUsage.remaining }}</span>
          </div>
        </div>
        <b-progress
          class="progress-usage"
          :value="routeOptimizationUsage.value"
          :max="routeOptimizationUsage.limit"
        />
        <div class="description-text text-secondary text-start">
           {{ $t('routeOptimization.quota.used', { min: routeOptimizationUsage.value, max: routeOptimizationUsage.limit }) }}
        </div>
      </div>
    </div>
    <div class="footer-wrapper">
      <McButton variant="secondary" :text="$t('global.action.close')" block @click="hideModal" />
      <div class="description-text text-secondary">
        {{ $t('routeOptimization.quota.contact') }}
      </div>
    </div>
  </b-modal>
</template>
<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  props: {
    routeOptimizationUsage: {
      type: Object,
      required: true,
    },
  },
  methods: {
    OpenModal() {
      this.$bvModal.show('usage-limit-dialog')
    },
    hideModal() {
      this.$bvModal.hide('usage-limit-dialog')
    },
  },
}
</script>
<style lang="scss" scoped>
.body-wrapper {
  .content-wrapper {
    display: flex;
    flex-direction: column;
    gap: 12px;

    .usage-limit-wrapper {
      display: flex;
      flex-direction: column;
      border: 1px solid #e6e7ec;
      border-radius: 8px;
      padding: 16px;
      gap: 8px;

      .progress-usage {
        border-radius: 8px;
      }
    }
  }

  .description-text {
    font-size: 11px;
  }

  .footer-wrapper {
    display: flex;
    flex-direction: column;
    padding: 24px 0 12px 0;
    gap: 12px;
  }
}
</style>
